document.querySelectorAll('.view-toggle').forEach(button => {
  button.addEventListener('click', () => {
    const back = button.getAttribute('aria-pressed') !== 'true';
    const image = button.closest('.product-image').querySelector('img');
    image.src = back ? button.dataset.back : button.dataset.front;
    image.alt = `${button.dataset.title}, ${back ? 'back' : 'front'} view`;
    button.setAttribute('aria-pressed', String(back));
    button.textContent = back ? 'Show front' : 'Show back';
  });
});
